import EmailVariant from "../EmailVariant";
import EnquiryModal from "../EnquiryModal";
const ConnectWithUsModal = ({ modalOpen, setModalOpen , variant }) => {
    if (variant === "email") {
    return <EmailVariant modalOpen={modalOpen} setModalOpen={setModalOpen} />;
  }

  return <EnquiryModal modalOpen={modalOpen} setModalOpen={setModalOpen} />;
};

export default ConnectWithUsModal;
